/**
 * Debug utilities for WebSocket functionality
 * Minimal implementation for production deployment
 */

// Simple debug flag - can be enabled for development
const DEBUG_ENABLED = false;

// Debug functions that conditionally log
export const debugWS = (...args) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] 🔌 WS DEBUG:`, ...args);
};

export const debugWSMessaging = (...args) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] 📡 WS-MSG DEBUG:`, ...args);
};

export const warnWS = (...args) => {
  const timestamp = new Date().toISOString();
  console.warn(`[${timestamp}] ⚠️ WS WARN:`, ...args);
};

export const warnWSMessaging = (...args) => {
  const timestamp = new Date().toISOString();
  console.warn(`[${timestamp}] ⚠️ WS-MSG WARN:`, ...args);
};

export const errorWS = (...args) => {
  const timestamp = new Date().toISOString();
  console.error(`[${timestamp}] ❌ WS ERROR:`, ...args);
};

export const errorWSMessaging = (...args) => {
  const timestamp = new Date().toISOString();
  console.error(`[${timestamp}] ❌ WS-MSG ERROR:`, ...args);
};

export const logWSLifecycle = (...args) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] 🔄 WS-LIFECYCLE:`, ...args);
};

export const logWSMessage = (...args) => {
  const timestamp = new Date().toISOString();
  console.log(`[${timestamp}] 📨 WS-MESSAGE:`, ...args);
};
